//Read
export class GetUserLogger {
    static readonly type = '[User Logger] Fetch';
}

//Update
export class SetUserLogger {
    static readonly type = '[User Logger] Update';
    constructor(public payload: any) { }
}